import Layout from "layout";
import React, { useState } from "react";
import {
  useGetAllUsers,
  useGetUserStats,
} from "utils/api/admin.api";
import UserStatsCards from "components/usersManagement/UserStatsCards";
import UserFilters from "components/usersManagement/UserFilters";
import UsersTable from "components/usersManagement/UsersTable";
import UserPagination from "components/usersManagement/UserPagination";

export default function UsersManagement() {
  const [searchValue, setSearchValue] = useState("");
  const [statusFilter, setStatusFilter] = useState<"active" | "inactive" | "all">("all");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);

  const { data, isLoading } = useGetAllUsers({
    page,
    limit,
    search_query: searchValue || undefined,
    status: statusFilter !== "all" ? statusFilter : undefined,
  });

  const { data: stats, isLoading: statsLoading } = useGetUserStats();

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
    setPage(1); // Reset to first page on search
  };

  const handleStatusFilterChange = (value: "active" | "inactive" | "all") => {
    setStatusFilter(value);
    setPage(1); // Reset to first page on filter change
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const totalPages = data ? Math.ceil(data.total / limit) : 1;

  return (
    <Layout>
      <div className="dashboard-main">
        <div className="main-wrapper max-w-5xl p-6">
          <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
            <ul className="flex flex-wrap items-center gap-3">
              <li>
                <p className="text-black-900 text-xl">Users Management</p>
              </li>
            </ul>
          </div>

          <UserStatsCards stats={stats} isLoading={statsLoading} />

          <UserFilters
            searchValue={searchValue}
            statusFilter={statusFilter}
            onSearchChange={handleSearchChange}
            onStatusFilterChange={handleStatusFilterChange}
          />

          <UsersTable users={data?.records} isLoading={isLoading} />

          {data && data.total > limit && (
            <UserPagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </Layout>
  );
}
